import { RegexNoOnlyEmoji } from "@fwa/src/utils/formUtils";
import { z } from "zod";

export const emJourneyValidation = z.object({
  teamTitle: z
    .string()
    .trim()
    .min(3, "Team name should be at least 3 characters.")
    .max(100, "Team name should be at most 100 characters.")
    .regex(
      /^((?!\s\s)[\s\S])*$/,
      "Team name should not contain adjacent spaces.",
    )
    .regex(RegexNoOnlyEmoji.pattern, RegexNoOnlyEmoji.message)
    .optional(),
  team: z
    .object({
      title: z.string(),
      uniqueId: z.string(),
    })
    .optional(),
});

export default emJourneyValidation;
